import { render, staticRenderFns } from "./DevelopmentDocuments.vue?vue&type=template&id=b8b49e9c&scoped=true"
import script from "./DevelopmentDocuments.vue?vue&type=script&lang=js"
export * from "./DevelopmentDocuments.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentDocuments.scss?vue&type=style&index=0&id=b8b49e9c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b49e9c",
  null
  
)

export default component.exports